import { render } from "./NSelect.vue?vue&type=template&id=53a9fae4&ts=true"
import script from "./NSelect.vue?vue&type=script&lang=ts"
export * from "./NSelect.vue?vue&type=script&lang=ts"

import "./NSelect.vue?vue&type=style&index=0&id=53a9fae4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__